import { Link } from "react-router-dom";
import { Crown, X, Zap, Check } from "lucide-react";

// Reusable upgrade-to-pro modal. Triggered when free users hit a quota or
// click a locked lab. Routes to /pricing for the actual checkout flow so
// Stripe credentials live in one place.
export default function UpgradeModal({ open, onClose, reason }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="upgrade-modal"
    >
      <div
        className="bg-[#141416] border border-[#00E5FF]/40 max-w-md w-full p-7 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-zinc-500 hover:text-white"
          data-testid="upgrade-modal-close"
        >
          <X size={16} />
        </button>
        <div className="flex items-center gap-2 mb-3">
          <Crown className="text-[#00E5FF]" size={18} />
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-mono">
            Upgrade to Pro
          </span>
        </div>
        <h2 className="font-display font-black text-2xl tracking-tight mb-3">
          {reason || "Free tier limit reached"}
        </h2>
        <p className="text-zinc-400 text-sm leading-relaxed mb-5">
          Pro is $19/mo and unlocks everything you need to actually pass the
          CCNA — including unlimited labs and the advanced multi-device topologies.
        </p>
        <ul className="space-y-2 text-sm text-zinc-200 mb-6">
          <Bullet>Unlimited labs (free = 3/month)</Bullet>
          <Bullet>Unlimited AI hints (free = 3/day)</Bullet>
          <Bullet>All 5 multi-device labs</Bullet>
          <Bullet>Full progress analytics</Bullet>
        </ul>
        <Link
          to="/pricing"
          onClick={onClose}
          className="w-full py-3 bg-[#00E5FF] text-black font-semibold hover:bg-[#00B8CC] transition-colors flex items-center justify-center gap-2"
          data-testid="upgrade-modal-cta"
        >
          <Zap size={14} /> upgrade to pro
        </Link>
        <button
          onClick={onClose}
          className="w-full mt-3 py-2 text-xs text-zinc-500 hover:text-zinc-200 font-mono uppercase tracking-widest"
        >
          not now
        </button>
      </div>
    </div>
  );
}

function Bullet({ children }) {
  return (
    <li className="flex items-center gap-2">
      <Check size={14} className="text-[#00E5FF]" />
      {children}
    </li>
  );
}
